import React, { useState } from 'react';
import axios from 'axios';
import './settings.css'; 

const Settings = () => {
  const [showProfileForm, setShowProfileForm] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState(false);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // API Integration: Updating User Profile
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/api/users/update', {
        name,
        email,
        phone: phoneNumber,
      });
      if (response.status === 200) {
        alert('Profile updated successfully!');
      } else {
        alert('Error updating profile.');
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Failed to update profile.');
    }
  };

  // API Integration: Resetting Password
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      return alert('Passwords do not match!');
    }

    try {
      const response = await axios.post('/api/users/reset-password', {
        currentPassword,
        newPassword,
      });
      if (response.status === 200) {
        alert('Password reset successfully!');
      } else {
        alert('Error resetting password.');
      }
    } catch (error) {
      console.error('Error resetting password:', error);
      alert('Failed to reset password.');
    }
  };

  return (
    <div className="settings-section">
      <h2>Settings</h2>

      <div className="settings-options">
        <button onClick={() => setShowProfileForm(!showProfileForm)}>
          {showProfileForm ? 'Hide Profile Form' : 'Show Profile Form'}
        </button>

        <button onClick={() => setShowPasswordForm(!showPasswordForm)}>
          {showPasswordForm ? 'Hide Password Form' : 'Show Password Form'}
        </button>
      </div>

      {/* Profile Update Form */}
      {showProfileForm && (
        <form onSubmit={handleUpdate}>
          <label>Company Name</label>
          <input 
            type="text" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            placeholder="Enter your name"
          />

          <label>Company Email</label>
          <input 
            type="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            placeholder="Enter company email"
          />

          <label>Phone Number</label>
          <input 
            type="tel" 
            value={phoneNumber} 
            onChange={(e) => setPhoneNumber(e.target.value)} 
            placeholder="Enter your phone number"
          />

          <button type="submit" className="submit-button">Update Profile</button>
        </form>
      )}

      {/* Password Reset Form */}
      {showPasswordForm && (
        <form onSubmit={handlePasswordReset}>
          <label>Current Password</label>
          <input 
            type="password" 
            value={currentPassword} 
            onChange={(e) => setCurrentPassword(e.target.value)} 
            placeholder="Enter current password"
          />

          <label>New Password</label>
          <input 
            type="password" 
            value={newPassword} 
            onChange={(e) => setNewPassword(e.target.value)} 
            placeholder="Enter new password"
          />

          <label>Confirm New Password</label>
          <input 
            type="password" 
            value={confirmPassword} 
            onChange={(e) => setConfirmPassword(e.target.value)} 
            placeholder="Confirm new password"
          />

          <button type="submit" className="submit-button">Reset Password</button>
        </form>
      )}
    </div>
  );
};

export default Settings;
